import React, { Component } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./AboutUs.css";
import about from "../../images/IMG_2092.png";

class AboutUs extends Component {
    render(){
        return(
            <>
            <div className="about-hero">
                <img src={about} className="about-image" alt="classroom"/>
                <div className="overlay-text">
                    <h1>Our Story</h1>
                    <p>
                    Improving the Future LLC is an educational entity that encompasses STEM Consulting, Special Education Services, Curriculum and Program Design, and After School Services including Tutoring.
                    </p>
                </div>
            </div>

            <div className="about-additional-text">
                <p>
                    <strong>Kaziya Watson:</strong> Kaziya has a Bachelor of Science in childhood education and Special Education, and a Master of Science in Special Education mild/moderate and severe. She has done many different jobs including advocating for student disability, ABA assistants, and special education testing, and is currently a Life skills teacher. Ms. Watson has been working with children for 8 years and has a passion that can not be denied. She is devoted to being a great educator in any way possible and helping every child that she can.
                </p>

                <p>
                    <strong>Dr. Stacey Williams:</strong> Dr. Williams has a Bachelor of Science in Health Education, a Master of Arts in Curriculum and Instruction, and a Ph.D. in Higher Education Administration with a dissertation focus on minority students in STEM (Science, Technology, Engineering, and Math) education. She holds many titles, including STEM educator, STEM consultant, STEM Coach, Curriculum developer, and Adjunct Professor. Dr. Williams has written curriculum, developed various STEM programs, and published. In addition, she has developed and implemented professional development for educators in various districts throughout Connecticut in STE(A)M, Science, Math, and Teaching Multicultural Students.
                </p>

                <p>
                    <strong>Dyami Watson Jr:</strong> Dyami holds a Bachelor of Science and a Master of Science in Computer Science. Dyami has previously worked as a software developer and has experience tutoring computer science students. He has worked on a variety of projects including mobile and web applications and has experience with JavaScript, Typescript, C, C++, C#, and more. His goal is to change the world with his technological prowess.
                </p>

                <p>
                    <strong>Jeremiah Altius:</strong> Jeremiah grew up on his family’s farm, where he developed a deep connection to the land and a strong work ethic. From planting and harvesting crops to managing livestock, he gained hands-on experience in sustainable farming and problem-solving in real-world conditions. His farming background has given him a practical perspective, resilience, and a dedication to hard work that shapes everything he does.
                </p>
            </div>
            </>
        );
    }
}
export default AboutUs;
